import Swiper from 'swiper/bundle';
// Swiper-CSS kommt ueber resources/scss/site.scss (im <head>, kein Aufblitzen)

var marginWidth = 0;

window.addEventListener('load',function() {
    
    if(document.getElementById('marginWidthProxy')) {
        marginWidth = document.getElementById('marginWidthProxy').clientWidth;
    }

    /*******************************************/
    /*
    /*  Mobile Nav
    */

    // Burger unter 1280px (header.scss): oeffnet .nav als Vollbild-Menue.
    // Schliesst per Knopf, Escape, Klick auf einen Menuelink (auch Anfrage-Popin)
    // und sobald das Fenster breit genug fuer die Desktop-Leiste wird.
    var navTrigger = document.querySelector('#header .rwd-trigger');
    if (navTrigger) {
        var navHeader = document.getElementById('header');
        var navDesktop = window.matchMedia('(min-width: 1280px)');

        var navSetzen = function (offen) {
            navHeader.classList.toggle('nav-open', offen);
            document.body.classList.toggle('scroll-lock', offen);
            navTrigger.setAttribute('aria-expanded', offen ? 'true' : 'false');
            navTrigger.setAttribute('aria-label', offen ? 'Menü schließen' : 'Menü öffnen');
        };

        navTrigger.addEventListener('click', function () {
            navSetzen(!navHeader.classList.contains('nav-open'));
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && navHeader.classList.contains('nav-open')) {
                navSetzen(false);
                navTrigger.focus();
            }
        });

        navHeader.querySelector('.nav').addEventListener('click', function (e) {
            var a = e.target.closest('a');
            if (a && a.getAttribute('href') !== '#') {
                navSetzen(false);
            }
        });

        navDesktop.addEventListener('change', function (e) {
            if (e.matches) {
                navSetzen(false);
            }
        });
    }

    /*******************************************/
    /*
    /*  Accordion
    */

    document.querySelectorAll('.wp-block-hv-accordion').forEach(function (el) {
        console.log(el);
        el.addEventListener('click', function () {
            var parentEl = el.parentElement;
            var doNotClose = parentEl.classList.contains('doNotClose');
            var dataClass = el.getAttribute('data-class');
            if (dataClass && document.querySelector('.' + dataClass)) {
                document.querySelector('.' + dataClass).classList.add('show');
            }
            var h = el.querySelector('.inner>div').clientHeight;
            document.querySelectorAll('.wp-block-hv-accordion').forEach(function (elOther) {
                if (elOther != el) {
                    elOther.querySelector('.inner').style.height = '0px';
                    elOther.classList.remove('open');
                }
            });
            if (el.classList.contains('open') && !doNotClose) {
                el.querySelector('.inner').style.height = '0px';
                el.classList.remove('open');
            } else {
                el.querySelector('.inner').style.height = h + 'px';
                el.classList.add('open');
                window.setTimeout(
                    function () {
                        var rect = el.getBoundingClientRect();
                        if (rect.top < 144) {
                            el.scrollIntoView();
                        }
                    }, 400
                )
            }
        });
        if (el.classList.contains('initialOpen')) {
            el.querySelector('.inner').style.height = el.querySelector('.inner>div').clientHeight + 'px';
            var dataClass = el.getAttribute('data-class');
            document.querySelector('.' + dataClass).classList.toggle('show');
        }
    });

    /*******************************************/
    /*
    /*  Zitate: rotierende Karten
    */

    document.querySelectorAll('.wp-block-hv-quotes .quotes').forEach(function (stage) {

        var cards = Array.prototype.filter.call(stage.children, function (el) {
            return el.classList.contains('quotes__item');
        });
        if (cards.length < 3) {
            return;
        }

        var active = 0;
        var timer = null;
        var paused = false;
        var interval = 7000;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function render() {
            cards.forEach(function (card, i) {
                var offset = (i - active + cards.length) % cards.length;
                var position = 'hidden';
                if (offset === 0) {
                    position = 'active';
                } else if (offset === 1) {
                    position = 'next';
                } else if (offset === cards.length - 1) {
                    position = 'prev';
                }
                card.setAttribute('data-position', position);
            });
        }

        function go(step) {
            active = (active + step + cards.length) % cards.length;
            render();
        }

        function start() {
            if (reduceMotion || timer) {
                return;
            }
            timer = window.setInterval(function () {
                if (!paused) {
                    go(1);
                }
            }, interval);
        }

        function stop() {
            window.clearInterval(timer);
            timer = null;
        }

        // Nach einer Nutzeraktion die Wartezeit neu beginnen
        function restart() {
            stop();
            start();
        }

        cards.forEach(function (card) {
            card.addEventListener('click', function () {
                var position = card.getAttribute('data-position');
                if (position === 'next') {
                    go(1);
                    restart();
                } else if (position === 'prev') {
                    go(-1);
                    restart();
                }
            });
        });

        // Pfeile unter der Buehne: zeigen, dass man blaettern kann. Per JS
        // ergaenzt, damit gespeicherte Bloecke gueltig bleiben.
        var nav = document.createElement('div');
        nav.className = 'quotes__nav';
        [
            { richtung: 'zurueck', step: -1, label: 'Vorheriges Zitat' },
            { richtung: 'weiter', step: 1, label: 'Nächstes Zitat' },
        ].forEach(function (pfeil) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'quotes__pfeil quotes__pfeil--' + pfeil.richtung;
            button.setAttribute('aria-label', pfeil.label);
            button.addEventListener('click', function () {
                go(pfeil.step);
                restart();
            });
            nav.appendChild(button);
        });
        stage.insertAdjacentElement('afterend', nav);

        stage.setAttribute('tabindex', '0');
        stage.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                go(1);
                restart();
            } else if (e.key === 'ArrowLeft') {
                e.preventDefault();
                go(-1);
                restart();
            }
        });

        stage.addEventListener('mouseenter', function () { paused = true; });
        stage.addEventListener('mouseleave', function () { paused = false; });
        stage.addEventListener('focusin', function () { paused = true; });
        stage.addEventListener('focusout', function () { paused = false; });

        var touchStartX = null;
        stage.addEventListener('touchstart', function (e) {
            touchStartX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
            if (touchStartX === null) {
                return;
            }
            var dx = e.changedTouches[0].clientX - touchStartX;
            touchStartX = null;
            if (Math.abs(dx) > 40) {
                go(dx < 0 ? 1 : -1);
                restart();
            }
        });

        // Nur rotieren, solange die Buehne im Viewport ist
        if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        start();
                    } else {
                        stop();
                    }
                });
            }, { threshold: 0.3 }).observe(stage);
        } else {
            start();
        }

        render();
        stage.classList.add('is-ready');
    });

    /*******************************************/
    /*
    /*  Bild-Laufband (hv/image-carousel)
    /*
    /*  Swiper mit Endlosschleife und Autoplay ohne Pause, linear (CSS). Die
    /*  Dauer je Schritt richtet sich nach der Breite der aktiven Kachel, damit
    /*  das Band gleichmaessig mit LAUFBAND_TEMPO px/s laeuft. Bei
    /*  prefers-reduced-motion steht das Band.
    */

    var LAUFBAND_TEMPO = 100;

    document.querySelectorAll('.wp-block-hv-image-carousel .image-carousel').forEach(function (el) {
        var anzahl = el.querySelectorAll('.swiper-slide').length;
        if (!anzahl) {
            return;
        }
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // --gap-2x aus dem CSS (column-gap), aendert sich am Breakpoint
        function abstand() {
            return parseFloat(getComputedStyle(el).columnGap) || 0;
        }

        function tempo(s) {
            var slide = s.slides[s.activeIndex];
            if (slide) {
                s.params.speed = Math.round((slide.offsetWidth + s.params.spaceBetween) / LAUFBAND_TEMPO * 1000);
            }
        }

        if (!reduceMotion) {
            el.classList.add('image-carousel--laufband');
        }

        var swiper = new Swiper(el, {
            slidesPerView: 'auto',
            spaceBetween: abstand(),
            loop: true,
            loopedSlides: anzahl,
            allowTouchMove: reduceMotion,
            speed: 400,
            autoplay: reduceMotion ? false : {
                delay: 0,
                disableOnInteraction: false,
            },
            on: {
                beforeResize: function (s) {
                    s.params.spaceBetween = abstand();
                },
                init: function (s) {
                    if (!reduceMotion) {
                        tempo(s);
                    }
                },
                transitionEnd: function (s) {
                    if (!reduceMotion) {
                        tempo(s);
                    }
                },
            },
        });

        // Band ist rein dekorativ (pointer-events: none im CSS): Bildlinks
        // auch per Tastatur nicht erreichbar machen
        el.querySelectorAll('.image-carousel__zoom').forEach(function (link) {
            link.setAttribute('tabindex', '-1');
        });

        // Nur laufen, solange das Band im Viewport ist
        if (!reduceMotion && 'IntersectionObserver' in window) {
            new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        swiper.autoplay.start();
                    } else {
                        swiper.autoplay.stop();
                    }
                });
            }).observe(el);
        }
    });

    /*******************************************/
    /*
    /*  Awards-Slider (hv/awards-slider)
    /*
    /*  Die Kinder (hv/awards-item) werden zu Slides. 2/3/4/5 sichtbar je
    /*  Breakpoint, Pfeile, langsames Autoplay mit Pause bei Hover. Passen alle
    /*  Awards auf einmal, sperrt watchOverflow den Slider und die Pfeile.
    */

    document.querySelectorAll('.wp-block-hv-awards-slider').forEach(function (block) {
        var el = block.querySelector('.awards-slider');
        var slides = el ? el.querySelectorAll('.swiper-wrapper > .awards__item') : [];
        if (!slides.length) {
            return;
        }
        slides.forEach(function (s) {
            s.classList.add('swiper-slide');
        });
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function abstand() {
            return parseFloat(getComputedStyle(el).columnGap) || 0;
        }

        new Swiper(el, {
            slidesPerView: 2,
            spaceBetween: abstand(),
            breakpoints: {
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
                1280: { slidesPerView: 6 },
            },
            rewind: true,
            watchOverflow: true,
            speed: 600,
            navigation: {
                prevEl: block.querySelector('.awards-slider__pfeil--zurueck'),
                nextEl: block.querySelector('.awards-slider__pfeil--weiter'),
            },
            a11y: {
                prevSlideMessage: 'Vorherige Auszeichnungen',
                nextSlideMessage: 'Weitere Auszeichnungen',
            },
            autoplay: reduceMotion ? false : {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            on: {
                beforeResize: function (s) {
                    s.params.spaceBetween = abstand();
                },
            },
        });
    });

    /*******************************************/
    /*
    /*  Schritte-Slider (hv/steps-slider)
    /*
    /*  Die Kinder (hv/steps) werden zu Slides. 1/2/3 sichtbar je Breakpoint,
    /*  Pfeile, kein Autoplay (Text zum Lesen). Passen alle Schritte auf
    /*  einmal, sperrt watchOverflow den Slider und die Pfeile.
    */

    document.querySelectorAll('.wp-block-hv-steps-slider').forEach(function (block) {
        var el = block.querySelector('.steps-slider');
        var slides = el ? el.querySelectorAll('.swiper-wrapper > .wp-block-hv-steps') : [];
        if (!slides.length) {
            return;
        }
        slides.forEach(function (s) {
            s.classList.add('swiper-slide');
        });

        function abstand() {
            return parseFloat(getComputedStyle(el).columnGap) || 0;
        }

        new Swiper(el, {
            slidesPerView: 1.1,
            spaceBetween: 10,
            breakpoints: {
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1440: { slidesPerView: 5 },
            },
            rewind: true,
            watchOverflow: true,
            speed: 600,
            navigation: {
                prevEl: block.querySelector('.steps-slider__pfeil--zurueck'),
                nextEl: block.querySelector('.steps-slider__pfeil--weiter'),
            },
            a11y: {
                prevSlideMessage: 'Vorheriger Schritt',
                nextSlideMessage: 'Nächster Schritt',
            },
            on: {
                beforeResize: function (s) {
                    s.params.spaceBetween = 10;
                },
            },
        });
    });

    /*******************************************/
    /*
    /*  Beitrags-Slider (hv/beitrags-slider)
    /*
    /*  Blog-Kacheln aus render.php. 1/2/3 sichtbar wie das Kachelraster der
    /*  Blogseite, Pfeile, kein Autoplay. Passen alle Beitraege auf einmal,
    /*  sperrt watchOverflow den Slider und die Pfeile.
    */

    document.querySelectorAll('.wp-block-hv-beitrags-slider').forEach(function (block) {
        var el = block.querySelector('.beitrags-slider');
        if (!el || !el.querySelector('.swiper-slide')) {
            return;
        }

        function abstand() {
            return parseFloat(getComputedStyle(el).columnGap) || 0;
        }

        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: abstand(),
            breakpoints: {
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
            },
            rewind: true,
            watchOverflow: true,
            speed: 600,
            navigation: {
                prevEl: block.querySelector('.slider-pfeil--zurueck'),
                nextEl: block.querySelector('.slider-pfeil--weiter'),
            },
            a11y: {
                prevSlideMessage: 'Vorherige Beiträge',
                nextSlideMessage: 'Weitere Beiträge',
            },
            on: {
                beforeResize: function (s) {
                    s.params.spaceBetween = abstand();
                },
            },
        });
    });

    /*******************************************/
    /*
    /*  Header
    */

    // Der Header ist sticky (header.scss). Sobald er klebt, entspricht seine
    // Viewport-Position seinem CSS-top. Dann bekommt er die Klasse "stuck",
    // damit Logo und obere Zeile ausgeblendet werden koennen.
    var header = document.getElementById("header");
    if(header) {
        var headerStickyTop = 0;
        var readStickyTop = function() {
            headerStickyTop = parseFloat(getComputedStyle(header).top) || 0;
        };
        // Home-Link in der gelben Leiste: nur sichtbar, solange der Header klebt.
        var homeLink = header.querySelector(".bottom > a");
        var updateStuck = function() {
            var stuck = header.getBoundingClientRect().top <= headerStickyTop + 1;
            header.classList.toggle("stuck", stuck);
            if(homeLink) homeLink.classList.toggle("show", stuck);
        };
        // Verlauf im Hero (hero26.scss, hero-programm.scss) bis zur Unterkante der gelben Leiste.
        // Gerechnet relativ zu #wrapall, damit Scrollen/Sticky das Mass nicht verfaelscht:
        // der Header sitzt ungeklebt an der Oberkante von #wrapall.
        var heroShade = document.querySelector(".wp-block-hv-hero26, .wp-block-hv-hero-programm");
        var headerBar = header.querySelector(".bottom");
        var wrapAll = document.getElementById("wrapall");
        var updateHeroShade = function() {
            if(!heroShade || !headerBar || !wrapAll) return;
            var barBottom = headerBar.getBoundingClientRect().bottom - header.getBoundingClientRect().top;
            var heroTop = heroShade.getBoundingClientRect().top - wrapAll.getBoundingClientRect().top;
            var shade = barBottom - heroTop;
            heroShade.style.setProperty("--hero-shade", shade > 0 ? shade + "px" : "0px");
        };

        readStickyTop();
        updateStuck();
        updateHeroShade();
        window.addEventListener("load", updateHeroShade);
        window.addEventListener("scroll", updateStuck, { passive: true });
        window.addEventListener("resize", function() {
            readStickyTop();
            updateStuck();
            updateHeroShade();
        });
    }

    /*******************************************/
    /*
    /*  Hash scrolling
    */

    if(window.location.hash) {
        if(el = document.getElementById(window.location.hash)) {
            el.scrollIntoView();
        }
    };

    document.querySelectorAll('.wp-block-hv-accordion h2').forEach(function (el) {
        console.log(el);
        el.addEventListener('click', function () {
            var parentEl = el.parentElement;
            var doNotClose = parentEl.classList.contains('doNotClose');
            var dataClass = el.getAttribute('data-class');
            if (dataClass && document.querySelector('.' + dataClass)) {
                document.querySelector('.' + dataClass).classList.add('show');
                document.querySelectorAll('.wp-block-greco-specials .description>:not(.' + dataClass + ')').forEach(function (el) {
                    el.classList.remove('show');
                });
            }
            var h = el.querySelector('.inner>div').clientHeight;
            document.querySelectorAll('.wp-block-ff-accordion').forEach(function (elOther) {
                if (elOther != el) {
                    elOther.querySelector('.inner').style.height = '0px';
                    elOther.classList.remove('open');
                }
            });
            if (el.classList.contains('open') && !doNotClose) {
                el.querySelector('.inner').style.height = '0px';
                el.classList.remove('open');
            } else {
                el.querySelector('.inner').style.height = h + 'px';
                el.classList.add('open');
                window.setTimeout(
                    function () {
                        var rect = el.getBoundingClientRect();
                        if (rect.top < 144) {
                            el.scrollIntoView();
                        }
                    }, 400
                )
            }
        });
        if (el.classList.contains('initialOpen')) {
            el.querySelector('.inner').style.height = el.querySelector('.inner>div').clientHeight + 'px';
            var dataClass = el.getAttribute('data-class');
            document.querySelector('.' + dataClass).classList.toggle('show');
        }
    });

});

/*******************************************/
/*
/*  Anfrage-Popin ("Ihre Anfrage")
/*
/*  Markup: parts/anfrage.php. Trigger: jeder Link mit ?anfrage=<Programmname>,
/*  z. B. /kontakt/?anfrage=die+Heldenakademie (Programm-Select vorbelegt,
/*  bleibt sichtbar) oder /kontakt/?anfrage= (Header-CTA, Programm frei waehlbar).
/*  Ohne JS fuehrt der Link normal auf die Kontaktseite.
/*
/*  Zweites Popin #anfrage-kommune (parts/anfrage-kommune.php) fuer Kommunen,
/*  Kreise und Traeger: Trigger ist jeder Link mit ?kommune, z. B. /kontakt/?kommune.
/*
/*  Drittes Popin #anfrage-ausbildung (parts/anfrage-ausbildung.php) fuer
/*  Bewerbungen zur Trainerausbildung: Trigger ist jeder Link mit ?bewerbung.
*/

(function () {
    // Ueber den Tag suchen: Redakteure vergeben "anfrage" auch als HTML-Anker
    // an Bloecke, getElementById wuerde dann den Block statt des Popins liefern
    var dialog = document.querySelector('dialog#anfrage');
    var kommune = document.querySelector('dialog#anfrage-kommune');
    var ausbildung = document.querySelector('dialog#anfrage-ausbildung');
    if (!dialog || typeof dialog.showModal !== 'function') {
        return;
    }

    var programm = '';

    function ohneArtikel(p) {
        return p.replace(/^(der|die|das|den|dem|ein|eine|einen)\s+/i, '').trim().toLowerCase();
    }

    // Select "Programm" (Feld 1) vorbelegen, wenn eine Option zum Link passt
    function setProgramm() {
        var select = dialog.querySelector('.anfrage-programm select, select[name="input_1"]');
        var fest = false;
        if (select && programm) {
            var wanted = ohneArtikel(programm);
            Array.prototype.forEach.call(select.options, function (opt) {
                var text = opt.text.trim().toLowerCase();
                if (!fest && opt.value && (text === wanted || text.indexOf(wanted) === 0)) {
                    select.value = opt.value;
                    fest = true;
                }
            });
            // Kein passendes Programm: keine Auswahl aus einem frueheren Oeffnen stehen lassen
            if (!fest) {
                select.value = '';
            }
        }
        dialog.classList.toggle('anfrage--programm-fest', fest);
    }

    function open(p) {
        programm = p;
        setProgramm();
        dialog.showModal();
        document.body.classList.add('scroll-lock');
        if (window.matchMedia('(min-width: 768px)').matches) {
            var first = dialog.querySelector('.gform_wrapper .gfield:not(.anfrage-programm) input:not([type="hidden"]), .gform_wrapper .gfield:not(.anfrage-programm) select');
            if (!dialog.classList.contains('anfrage--programm-fest')) {
                first = dialog.querySelector('.anfrage-programm select') || first;
            }
            if (first) {
                first.focus();
            }
        }
    }

    // Popins ohne Vorbelegung (Kommune, Ausbildung)
    function openEinfach(d) {
        d.showModal();
        document.body.classList.add('scroll-lock');
        if (window.matchMedia('(min-width: 768px)').matches) {
            var first = d.querySelector('.gform_wrapper input:not([type="hidden"]), .gform_wrapper select');
            if (first) {
                first.focus();
            }
        }
    }

    document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href*="anfrage="], a[href*="kommune"], a[href*="bewerbung"]');
        if (!a) {
            return;
        }
        var params;
        try {
            params = new URL(a.href, window.location.href).searchParams;
        } catch (err) {
            return;
        }
        if (kommune && params.has('kommune')) {
            e.preventDefault();
            openEinfach(kommune);
            return;
        }
        if (ausbildung && params.has('bewerbung')) {
            e.preventDefault();
            openEinfach(ausbildung);
            return;
        }
        if (!params.has('anfrage')) {
            return;
        }
        e.preventDefault();
        open((params.get('anfrage') || '').trim());
    });

    // Footer-Formular: Wer im Select "Wofuer interessieren Sie sich?" etwas
    // anderes als "Allgemeine Anfrage" waehlt, bekommt das Anfrage-Popin
    // (Programm vorbelegt, sofern es dort eine passende Option gibt).
    // Das Footer-Select springt zurueck, das Footer-Formular bleibt allgemein.
    document.addEventListener('change', function (e) {
        var select = e.target;
        if (!select.matches || !select.matches('footer select') || select.closest('dialog')) {
            return;
        }
        var allgemein = select.options[0];
        if (!allgemein || allgemein.value !== 'Allgemeine Anfrage' || select.selectedIndex === 0) {
            return;
        }
        var wahl = select.options[select.selectedIndex].text.replace(/^Programm:\s*/i, '').trim();
        select.selectedIndex = 0;
        open(wahl);
    });

    [dialog, kommune, ausbildung].forEach(function (d) {
        if (!d) {
            return;
        }
        d.querySelector('.anfrage__close').addEventListener('click', function () {
            d.close();
        });

        // Klick auf den Backdrop schliesst (Ziel ist dann das <dialog> selbst)
        d.addEventListener('click', function (e) {
            if (e.target === d) {
                d.close();
            }
        });

        // Escape loest nativ "close" aus, daher Scroll-Lock hier aufheben
        d.addEventListener('close', function () {
            document.body.classList.remove('scroll-lock');
        });
    });

    // Gravity Forms rendert per Ajax neu (Validierungsfehler): Vorbelegung erneut setzen
    if (window.jQuery) {
        window.jQuery(document).on('gform_post_render', function (e, formId) {
            if (dialog.querySelector('#gform_' + formId)) {
                setProgramm();
            }
        });
    }
})();

/*******************************************/
/*
/*  Reiter (Block hv/reiter)
/*
/*  Baut aus den enthaltenen hv/feature-quer-Boxen die Reiterleiste (ab
/*  1024px) und je Box einen Accordion-Kopf (darunter). Text von Reiter und
/*  Kopf ist die Eyebrow der Box. Ohne JS stehen die Boxen untereinander.
*/

(function () {
    var desktop = window.matchMedia('(min-width: 1024px)');

    // Optionales Icon der Box vor den Reitertext setzen: bevorzugt das
    // Inline-SVG aus lib/icons.php (template.reiter__icon-vorlage), sonst
    // als <img> aus data-reiter-icon.
    function reiterIcon(ziel, panel) {
        var vorlage = panel.querySelector(':scope > template.reiter__icon-vorlage');
        var icon;
        if (vorlage && vorlage.content.firstElementChild) {
            icon = vorlage.content.firstElementChild.cloneNode(true);
        } else {
            var src = panel.getAttribute('data-reiter-icon');
            if (!src) {
                return;
            }
            icon = document.createElement('img');
            icon.className = 'reiter__icon';
            icon.src = src;
            icon.alt = '';
            icon.setAttribute('aria-hidden', 'true');
        }
        ziel.insertBefore(icon, ziel.firstChild);
    }

    document.querySelectorAll('.wp-block-hv-reiter').forEach(function (reiter, r) {
        var panels = Array.prototype.slice.call(
            reiter.querySelectorAll('.reiter__panels > .wp-block-hv-feature-quer'));
        if (!panels.length) {
            return;
        }
        var basis = reiter.id || 'reiter-' + (r + 1);
        var nav = document.createElement('div');
        nav.className = 'reiter__nav';
        nav.setAttribute('role', 'tablist');
        var tabs = [];
        var koepfe = [];
        var aktiv = 0;

        function setze(index) {
            aktiv = index;
            panels.forEach(function (panel, j) {
                var an = j === index;
                panel.classList.toggle('is-open', an);
                tabs[j].classList.toggle('is-active', an);
                tabs[j].setAttribute('aria-selected', an ? 'true' : 'false');
                tabs[j].tabIndex = an ? 0 : -1;
                koepfe[j].classList.toggle('is-open', an);
                koepfe[j].setAttribute('aria-expanded', an ? 'true' : 'false');
            });
        }

        panels.forEach(function (panel, i) {
            var eyebrow = panel.querySelector('.eyebrow');
            var headline = panel.querySelector('.feature-quer__headline');
            var text = (eyebrow || headline) ? (eyebrow || headline).textContent.trim() : 'Reiter ' + (i + 1);
            panel.id = panel.id || basis + '-' + (i + 1);
            panel.classList.add('reiter__panel');
            panel.setAttribute('role', 'tabpanel');

            var tab = document.createElement('button');
            tab.type = 'button';
            tab.className = 'reiter__tab';
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', panel.id);
            tab.innerHTML = '<span class="reiter__tab-text"></span>';
            tab.querySelector('.reiter__tab-text').textContent = text;
            reiterIcon(tab, panel);
            tab.addEventListener('click', function () {
                setze(i);
            });
            tab.addEventListener('keydown', function (e) {
                var ziel = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : null;
                if (ziel === null) {
                    return;
                }
                ziel = (ziel + panels.length) % panels.length;
                setze(ziel);
                tabs[ziel].focus();
            });
            nav.appendChild(tab);
            tabs.push(tab);

            var kopf = document.createElement('button');
            kopf.type = 'button';
            kopf.className = 'reiter__kopf';
            kopf.setAttribute('aria-controls', panel.id);
            kopf.innerHTML = '<span class="reiter__kopf-text"></span>'
                + '<span class="reiter__trigger" aria-hidden="true"><span class="plus"></span><span class="minus"></span></span>';
            kopf.querySelector('.reiter__kopf-text').textContent = text;
            reiterIcon(kopf, panel);
            kopf.addEventListener('click', function () {
                setze(aktiv === i ? -1 : i);
            });
            panel.parentNode.insertBefore(kopf, panel);
            koepfe.push(kopf);
        });

        reiter.insertBefore(nav, reiter.firstChild);
        reiter.classList.add('reiter--aktiv');
        setze(0);

        // Auf dem Desktop ist immer ein Reiter offen, auch wenn mobil alle zu waren.
        desktop.addEventListener('change', function (e) {
            if (e.matches && aktiv < 0) {
                setze(0);
            }
        });
    });
})();

/*******************************************/
/*
/*  Presse-Archiv (Block hv/presse-archiv)
/*
/*  Filtert die Eintraege nach Thema und Format (Chips mit aria-pressed).
/*  Ein Eintrag passt, wenn sein data-thema das gewaehlte Thema enthaelt
/*  ("auszeichnung" steht dort mit) und data-format gleich ist. Leere Jahre
/*  werden ausgeblendet. Der Zustand steht in der URL (?thema=&format=), damit
/*  man auf eine Auswahl verlinken kann. Ohne JS steht die ganze Liste da.
*/

(function () {
    document.querySelectorAll('[data-presse-archiv]').forEach(function (archiv) {
        var gruppen = archiv.querySelectorAll('.presse-archiv__filter');
        if (!gruppen.length) {
            return;
        }
        var eintraege = archiv.querySelectorAll('.presse-archiv__eintrag');
        var jahre = archiv.querySelectorAll('.presse-archiv__jahr');
        var anzahl = archiv.querySelector('[data-anzahl]');
        var leer = archiv.querySelector('[data-leer]');
        var wahl = { thema: '', format: '' };

        function anwenden() {
            var sichtbar = 0;
            eintraege.forEach(function (e) {
                var passt = (!wahl.thema || (' ' + e.dataset.thema + ' ').indexOf(' ' + wahl.thema + ' ') > -1)
                    && (!wahl.format || e.dataset.format === wahl.format);
                e.hidden = !passt;
                if (passt) {
                    sichtbar++;
                }
            });
            jahre.forEach(function (j) {
                j.hidden = !j.querySelector('.presse-archiv__eintrag:not([hidden])');
            });
            if (anzahl) {
                anzahl.textContent = sichtbar === 1 ? '1 Beitrag' : sichtbar + ' Beiträge';
            }
            leer.hidden = sichtbar > 0;
        }

        function markieren(gruppe) {
            gruppe.querySelectorAll('.presse-archiv__chip').forEach(function (c) {
                c.setAttribute('aria-pressed', c.dataset.wert === wahl[gruppe.dataset.gruppe] ? 'true' : 'false');
            });
        }

        function urlSchreiben() {
            var url = new URL(window.location.href);
            ['thema', 'format'].forEach(function (k) {
                if (wahl[k]) {
                    url.searchParams.set(k, wahl[k]);
                } else {
                    url.searchParams.delete(k);
                }
            });
            history.replaceState(null, '', url);
        }

        // Startwerte aus der URL, nur wenn es den Chip gibt
        var params = new URLSearchParams(window.location.search);
        gruppen.forEach(function (gruppe) {
            var k = gruppe.dataset.gruppe;
            var wert = params.get(k) || '';
            if (wert && gruppe.querySelector('.presse-archiv__chip[data-wert="' + CSS.escape(wert) + '"]')) {
                wahl[k] = wert;
            }
            markieren(gruppe);

            gruppe.addEventListener('click', function (ev) {
                var chip = ev.target.closest('.presse-archiv__chip');
                if (!chip) {
                    return;
                }
                wahl[k] = chip.dataset.wert;
                markieren(gruppe);
                anwenden();
                urlSchreiben();
            });
        });
        anwenden();
    });
})();

/*******************************************/
/*
/*  core/video: Play-Symbol als Overlay, solange das Video nicht laeuft.
/*  Klick auf das Symbol startet das Video; bei Pause oder Ende kommt es
/*  zurueck. Die nativen Controls bleiben darunter bedienbar.
*/

(function () {
    var playIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75" aria-hidden="true" focusable="false">'
        + '<path fill="currentColor" d="M 13.5 6 C 9.375 6 6 9.375 6 13.5 L 6 61.5 C 6 65.625 9.375 69 13.5 69 L 61.5 69 C 65.625 69 69 65.625 69 61.5 L 69 13.5 C 69 9.375 65.625 6 61.5 6 Z M 13.5 9 L 61.5 9 C 64.003906 9 66 10.996094 66 13.5 L 66 61.5 C 66 64.003906 64.003906 66 61.5 66 L 13.5 66 C 10.996094 66 9 64.003906 9 61.5 L 9 13.5 C 9 10.996094 10.996094 9 13.5 9 Z M 28.5 21.253906 L 28.5 53.746094 L 53.773438 37.5 Z M 31.5 26.746094 L 48.226562 37.5 L 31.5 48.253906 Z M 31.5 26.746094 "/>'
        + '</svg>';

    document.querySelectorAll('.wp-block-video').forEach(function (figure) {
        var video = figure.querySelector('video');
        if (!video) {
            return;
        }

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'wp-block-video__play';
        button.setAttribute('aria-label', 'Video abspielen');
        button.innerHTML = playIcon;
        figure.appendChild(button);

        var setzen = function () {
            figure.classList.toggle('is-playing', !video.paused && !video.ended);
        };

        button.addEventListener('click', function () {
            video.play();
        });
        video.addEventListener('play', setzen);
        video.addEventListener('pause', setzen);
        video.addEventListener('ended', setzen);
        setzen();
    });
})();
